import { recover, resetSubmitState } from "../../../modules/recovery";
import { onAuthModalClose } from "../../../modules/login";

const initialState = {};

export const passwordRecoveryReducer = (state = initialState, action) => {
  return state;
};

export const mapStateToProps = (state) => {
  return state.recoveryReducer;
};

export const mapDispatchToProps = {
  recover,
  resetSubmitState,
  onAuthModalClose,
};
